// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/about-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#intro {
  width: 100%;
  min-height: 100vh;
  background-color: #60b5ff;
  background-size: cover;
  overflow: hidden;
  position: relative;
}

@media (min-width: 1024px) {
  #intro {
    background-attachment: fixed;
  }
}
#intro:before {
  content: "";
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
}

#intro .intro-container {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 90px;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 0 15px;
}

@media (max-width: 991px) {
  #intro .intro-container {
    top: 70px;
  }
}
#intro h1 {
  color: #fff;
  font-family: "Raleway", sans-serif;
  font-size: 80px;
  font-weight: 600;
  text-transform: uppercase;
}

#intro h1 span {
  color: #3985cb;
}

@media (max-width: 991px) {
  #intro h1 {
    font-size: 34px;
  }
}
#intro p {
  color: #ebebeb;
  font-weight: 700;
  font-size: 20px;
}

@media (max-width: 991px) {
  #intro p {
    font-size: 16px;
  }
}
#intro .play-btn {
  width: 94px;
  height: 94px;
  background: radial-gradient(#3985cb 50%, rgba(101, 111, 150, 0.15) 52%);
  border-radius: 50%;
  display: block;
  position: relative;
  overflow: hidden;
}

#intro .play-btn::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-40%) translateY(-50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 15px solid #fff;
  z-index: 100;
  transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

#intro .play-btn:before {
  content: "";
  position: absolute;
  width: 120px;
  height: 120px;
  animation-delay: 0s;
  animation: pulsate-btn 2s;
  animation-direction: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: steps;
  opacity: 1;
  border-radius: 50%;
  border: 2px solid rgba(163, 163, 163, 0.4);
  top: -15%;
  left: -15%;
  background: rgba(198, 16, 0, 0);
}

#intro .play-btn:hover::after {
  border-left: 15px solid #3985cb;
  transform: scale(20);
}

#intro .play-btn:hover::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-40%) translateY(-50%);
  width: 0;
  height: 0;
  border: none;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 15px solid #fff;
  z-index: 200;
  animation: none;
  border-radius: 0;
}

#intro .about-btn {
  font-family: "Raleway", sans-serif;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 12px 32px;
  border-radius: 50px;
  transition: 0.5s;
  line-height: 1;
  margin: 10px;
  color: #fff;
  animation-delay: 0.8s;
  border: 2px solid #3985cb;
}

#intro .about-btn:hover {
  background: #3985cb;
  color: #fff;
}
@keyframes pulsate-btn {
  0% {
    transform: scale(0.6, 0.6);
    opacity: 1;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}
#about {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  overflow: hidden;
  position: relative;
  color: #fff;
  padding: 60px 0 40px 0;
}

@media (min-width: 1024px) {
  #about {
    background-attachment: fixed;
  }
}
#about:before {
  content: "";
  background: rgba(13, 20, 41, 0.2);
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
}

#about h2 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #fff;
}

#about h3 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #fff;
}

#about p {
  font-size: 1.25rem;
  margin-bottom: 20px;
  color: #fff;
}

#speakers {
  padding: 10px 0 30px 0;
}

#speakers .speaker {
  position: relative;
  overflow: hidden;
  margin-bottom: 30px;
}

#speakers .speaker .details {
  background: rgba(6, 12, 34, 0.76);
  position: absolute;
  left: 0;
  bottom: -30px;
  right: 0;
  text-align: center;
  padding-top: 10px;
  transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);
}

#speakers .speaker .details h3 {
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 5px;
}

#speakers .speaker .details p {
  color: #fff;
  font-size: 15px;
  margin-bottom: 10px;
  font-style: italic;
}

#speakers .speaker .details .social {
  height: 30px;
}

#speakers .speaker .details a {
  color: #fff;
}

#speakers .speaker .details a:hover {
  color: #3985cb;
}

#speakers .speaker:hover .details {
  bottom: 0;
}

#speakers-details {
  padding: 60px 0;
}

#speakers-details .details h2 {
  color: #112363;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 10px;
}

#speakers-details .details .social {
  margin-bottom: 15px;
}

#speakers-details .details .social a {
  background: #e9edfb;
  color: #112363;
  line-height: 1;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding-top: 9px;
}

#speakers-details .details .social a:hover {
  background: #3985cb;
  color: #fff;
}

#speakers-details .details .social a i {
  font-size: 18px;
}

#speakers-details .details p {
  color: #112363;
  font-size: 15px;
  margin-bottom: 10px;
}

.section-header {
  margin-top: 15px;
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 20px;
}

.section-header::before {
  content: "";
  position: absolute;
  display: block;
  width: 60px;
  height: 5px;
  background: #3985cb;
  bottom: 0;
  left: calc(50% - 25px);
}

.section-header h2 {
  font-size: 36px;
  text-transform: uppercase;
  text-align: center;
  font-weight: 700;
  margin-bottom: 10px;
}

.section-header p {
  text-align: center;
  padding: 0;
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #9195a2;
}

.section-with-bg {
  background-color: #f6f7fd;
}

#gallery {
  padding: 60px 350px 60px 350px;
  overflow: hidden;
}

@media (max-width: 1350px) {
  #gallery {
    padding: 60px 170px 60px 170px;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  #gallery {
    padding: 60px;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  #gallery {
    padding: 40px;
    overflow: hidden;
  }
}
@media (max-width: 450px) {
  #gallery {
    padding: 60px 10px 60px 10px;
    overflow: hidden;
  }
}
#gallery .owl-nav,
#gallery .owl-dots {
  margin-top: 25px;
  text-align: center;
}

#gallery .owl-item {
  border-left: 2px solid #fff;
  border-right: 2px solid #fff;
}

#gallery .owl-dot {
  display: inline-block;
  margin: 0 5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ddd;
}

#gallery .owl-dot.active {
  background-color: #f82249;
}

#gallery .gallery-carousel .owl-stage-outer {
  overflow: visible;
}

#gallery .gallery-carousel .center {
  border: 6px solid #f82249;
  margin: -10px;
  box-sizing: content-box;
  padding: 4px;
  background: #fff;
  z-index: 1;
}

.clients .clients-wrap {
  border-top: 1px solid #f1eeed;
  border-left: 1px solid #f1eeed;
}

.clients .client-logo {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #f1eeed;
  border-bottom: 1px solid #f1eeed;
  overflow: hidden;
  background: #fff;
  height: 100px;
}

.clients .client-logo img {
  transition: all 0.3s ease-in-out;
  height: 60px;
  filter: grayscale(100%);
}

.clients .client-logo:hover img {
  filter: none;
  transform: scale(1.1);
}

#footer {
  background: #101522;
  padding: 25px 0px;
  color: #eee;
  font-size: 14px;
  text-align: center;
  min-width: 100vw;
  bottom: 0;
}

.clicapLogo {
  width: 60rem;
  height: 15rem;
}

@media (max-width: 1200px) {
  .clicapLogo {
    width: 40rem;
    height: 10rem;
  }
}
@media (max-width: 900px) {
  .clicapLogo {
    width: 28rem;
    height: 7rem;
  }
}
@media (max-width: 480px) {
  .clicapLogo {
    width: 20rem;
    height: 5rem;
  }
}
.introSection {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}

#count {
  margin-top: 2rem;
}

*,
*:before,
*:after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

input[type=date] {
  background-color: #0080ff;
  padding: 15px;
  color: #ffffff;
  font-size: 18px;
  border: none;
  outline: none;
  border-radius: 5px;
}

::-webkit-calendar-picker-indicator {
  background-color: #ffffff;
  padding: 5px;
  cursor: pointer;
  border-radius: 3px;
}

.divIntro {
  height: 33.33vh;
}

@media (max-width: 480px) {
  .divIntro {
    height: auto;
    margin-bottom: 30px;
  }
}
.img-authorities {
  max-width: 80%;
}`, "",{"version":3,"sources":["webpack://./src/components/Start/start.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EAEA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE;IACE,4BAAA;EAAF;AACF;AAGA;EACE,WAAA;EAGA,SAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAHF;;AAMA;EACE;IACE,SAAA;EAHF;AACF;AAMA;EACE,WAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE;IACE,eAAA;EAJF;AACF;AAOA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AALF;;AAQA;EACE;IACE,eAAA;EALF;AACF;AAQA;EACE,WAAA;EACA,YAAA;EACA,uEAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,4BAAA;EACA,YAAA;EACA,4DAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EAEA,mBAAA;EAEA,yBAAA;EAEA,6BAAA;EAEA,mCAAA;EAEA,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,0CAAA;EACA,SAAA;EACA,UAAA;EACA,+BAAA;AANF;;AASA;EACE,+BAAA;EACA,oBAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,kCAAA;EACA,qCAAA;EACA,4BAAA;EACA,YAAA;EAEA,eAAA;EACA,gBAAA;AANF;;AASA;EACE,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EAEA,qBAAA;EACA,yBAAA;AANF;;AASA;EACE,mBAAA;EACA,WAAA;AANF;AAoBA;EACE;IACE,0BAAA;IACA,UAAA;EAPF;EASA;IACE,sBAAA;IACA,UAAA;EAPF;AACF;AAUA;EACE,mDAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AARF;;AAWA;EACE;IACE,4BAAA;EARF;AACF;AAWA;EACE,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AATF;;AAYA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AATF;;AAYA;EACE,eAAA;EACA,iBAAA;EAEA,mBAAA;EACA,WAAA;AAVF;;AAaA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;AAVF;;AAaA;EACE,sBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,iCAAA;EACA,kBAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,0DAAA;AAVF;;AAaA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,YAAA;AAVF;;AAaA;EACE,WAAA;AAVF;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,SAAA;AAVF;;AAaA;EACE,eAAA;AAVF;;AAaA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,WAAA;AAVF;;AAaA;EACE,eAAA;AAVF;;AAaA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAVF;;AAaA;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;AAVF;;AAaA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAVF;;AAaA;EACE,yBAAA;AAVF;;AAaA;EACE,8BAAA;EACA,gBAAA;AAVF;;AAaA;EACE;IACE,8BAAA;IACA,gBAAA;EAVF;AACF;AAaA;EACE;IACE,aAAA;IACA,gBAAA;EAXF;AACF;AAcA;EACE;IACE,aAAA;IACA,gBAAA;EAZF;AACF;AAeA;EACE;IACE,4BAAA;IACA,gBAAA;EAbF;AACF;AAgBA;;EAEE,gBAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,2BAAA;EACA,4BAAA;AAdF;;AAiBA;EACE,qBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAdF;;AAiBA;EACE,yBAAA;AAdF;;AAiBA;EACE,iBAAA;AAdF;;AAiBA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AAdF;;AAiBA;EACE,6BAAA;EACA,8BAAA;AAdF;;AAiBA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAdF;;AAiBA;EACE,gCAAA;EACA,YAAA;EAEA,uBAAA;AAdF;;AAiBA;EAEE,YAAA;EACA,qBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AAdF;;AAqCA;EACE,YAAA;EACA,aAAA;AAlCF;;AAqCA;EACE;IACE,YAAA;IACA,aAAA;EAlCF;AACF;AAqCA;EACE;IACE,YAAA;IACA,YAAA;EAnCF;AACF;AAsCA;EACE;IACE,YAAA;IACA,YAAA;EApCF;AACF;AAuCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AArCF;;AAwCA;EACE,gBAAA;AArCF;;AAwCA;;;EAGE,UAAA;EACA,SAAA;EACA,sBAAA;AArCF;;AAuCA;EACE,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AApCF;;AAsCA;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAnCF;;AAsCA;EACE,eAAA;AAnCF;;AAsCA;EACE;IACE,YAAA;IACA,mBAAA;EAnCF;AACF;AAsCA;EACE,cAAA;AApCF","sourcesContent":["#intro {\n  width: 100%;\n  min-height: 100vh;\n  // background: url(../../assets/slide-1.jpg) top center;\n  background-color: #60b5ff;\n  background-size: cover;\n  overflow: hidden;\n  position: relative;\n}\n\n@media (min-width: 1024px) {\n  #intro {\n    background-attachment: fixed;\n  }\n}\n\n#intro:before {\n  content: \"\";\n  // background: rgba(6, 12, 34, 0.8);\n  // position: absolute;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n#intro .intro-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  top: 90px;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n  padding: 0 15px;\n}\n\n@media (max-width: 991px) {\n  #intro .intro-container {\n    top: 70px;\n  }\n}\n\n#intro h1 {\n  color: #fff;\n  font-family: \"Raleway\", sans-serif;\n  font-size: 80px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n#intro h1 span {\n  color: #3985cb;\n}\n\n@media (max-width: 991px) {\n  #intro h1 {\n    font-size: 34px;\n  }\n}\n\n#intro p {\n  color: #ebebeb;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n@media (max-width: 991px) {\n  #intro p {\n    font-size: 16px;\n  }\n}\n\n#intro .play-btn {\n  width: 94px;\n  height: 94px;\n  background: radial-gradient(#3985cb 50%, rgba(101, 111, 150, 0.15) 52%);\n  border-radius: 50%;\n  display: block;\n  position: relative;\n  overflow: hidden;\n}\n\n#intro .play-btn::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-40%) translateY(-50%);\n  width: 0;\n  height: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 15px solid #fff;\n  z-index: 100;\n  transition: all 400ms cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n\n#intro .play-btn:before {\n  content: \"\";\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  -webkit-animation-delay: 0s;\n  animation-delay: 0s;\n  -webkit-animation: pulsate-btn 2s;\n  animation: pulsate-btn 2s;\n  -webkit-animation-direction: forwards;\n  animation-direction: forwards;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-timing-function: steps;\n  animation-timing-function: steps;\n  opacity: 1;\n  border-radius: 50%;\n  border: 2px solid rgba(163, 163, 163, 0.4);\n  top: -15%;\n  left: -15%;\n  background: rgba(198, 16, 0, 0);\n}\n\n#intro .play-btn:hover::after {\n  border-left: 15px solid #3985cb;\n  transform: scale(20);\n}\n\n#intro .play-btn:hover::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-40%) translateY(-50%);\n  width: 0;\n  height: 0;\n  border: none;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-left: 15px solid #fff;\n  z-index: 200;\n  -webkit-animation: none;\n  animation: none;\n  border-radius: 0;\n}\n\n#intro .about-btn {\n  font-family: \"Raleway\", sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: 1px;\n  display: inline-block;\n  padding: 12px 32px;\n  border-radius: 50px;\n  transition: 0.5s;\n  line-height: 1;\n  margin: 10px;\n  color: #fff;\n  -webkit-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n  border: 2px solid #3985cb;\n}\n\n#intro .about-btn:hover {\n  background: #3985cb;\n  color: #fff;\n}\n\n@-webkit-keyframes pulsate-btn {\n  0% {\n    transform: scale(0.6, 0.6);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1, 1);\n    opacity: 0;\n  }\n}\n\n@keyframes pulsate-btn {\n  0% {\n    transform: scale(0.6, 0.6);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1, 1);\n    opacity: 0;\n  }\n}\n\n#about {\n  background: url(\"../../assets/about-bg.jpg\");\n  background-size: cover;\n  overflow: hidden;\n  position: relative;\n  color: #fff;\n  padding: 60px 0 40px 0;\n}\n\n@media (min-width: 1024px) {\n  #about {\n    background-attachment: fixed;\n  }\n}\n\n#about:before {\n  content: \"\";\n  background: rgba(13, 20, 41, 0.2);\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n#about h2 {\n  font-size: 2rem;\n  font-weight: bold;\n  margin-bottom: 10px;\n  color: #fff;\n}\n\n#about h3 {\n  font-size: 2rem;\n  font-weight: bold;\n  // text-transform: uppercase;\n  margin-bottom: 10px;\n  color: #fff;\n}\n\n#about p {\n  font-size: 1.25rem;\n  margin-bottom: 20px;\n  color: #fff;\n}\n\n#speakers {\n  padding: 10px 0 30px 0;\n}\n\n#speakers .speaker {\n  position: relative;\n  overflow: hidden;\n  margin-bottom: 30px;\n}\n\n#speakers .speaker .details {\n  background: rgba(6, 12, 34, 0.76);\n  position: absolute;\n  left: 0;\n  bottom: -30px;\n  right: 0;\n  text-align: center;\n  padding-top: 10px;\n  transition: all 300ms cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n#speakers .speaker .details h3 {\n  color: #fff;\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n#speakers .speaker .details p {\n  color: #fff;\n  font-size: 15px;\n  margin-bottom: 10px;\n  font-style: italic;\n}\n\n#speakers .speaker .details .social {\n  height: 30px;\n}\n\n#speakers .speaker .details a {\n  color: #fff;\n}\n\n#speakers .speaker .details a:hover {\n  color: #3985cb;\n}\n\n#speakers .speaker:hover .details {\n  bottom: 0;\n}\n\n#speakers-details {\n  padding: 60px 0;\n}\n\n#speakers-details .details h2 {\n  color: #112363;\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n#speakers-details .details .social {\n  margin-bottom: 15px;\n}\n\n#speakers-details .details .social a {\n  background: #e9edfb;\n  color: #112363;\n  line-height: 1;\n  display: inline-block;\n  text-align: center;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  padding-top: 9px;\n}\n\n#speakers-details .details .social a:hover {\n  background: #3985cb;\n  color: #fff;\n}\n\n#speakers-details .details .social a i {\n  font-size: 18px;\n}\n\n#speakers-details .details p {\n  color: #112363;\n  font-size: 15px;\n  margin-bottom: 10px;\n}\n\n.section-header {\n  margin-top: 15px;\n  margin-bottom: 30px;\n  position: relative;\n  padding-bottom: 20px;\n}\n\n.section-header::before {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 60px;\n  height: 5px;\n  background: #3985cb;\n  bottom: 0;\n  left: calc(50% - 25px);\n}\n\n.section-header h2 {\n  font-size: 36px;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.section-header p {\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: #9195a2;\n}\n\n.section-with-bg {\n  background-color: #f6f7fd;\n}\n\n#gallery {\n  padding: 60px 350px 60px 350px;\n  overflow: hidden;\n}\n\n@media (max-width: 1350px) {\n  #gallery {\n    padding: 60px 170px 60px 170px;\n    overflow: hidden;\n  }\n}\n\n@media (max-width: 1200px) {\n  #gallery {\n    padding: 60px;\n    overflow: hidden;\n  }\n}\n\n@media (max-width: 1000px) {\n  #gallery {\n    padding: 40px;\n    overflow: hidden;\n  }\n}\n\n@media (max-width: 450px) {\n  #gallery {\n    padding: 60px 10px 60px 10px;\n    overflow: hidden;\n  }\n}\n\n#gallery .owl-nav,\n#gallery .owl-dots {\n  margin-top: 25px;\n  text-align: center;\n}\n\n#gallery .owl-item {\n  border-left: 2px solid #fff;\n  border-right: 2px solid #fff;\n}\n\n#gallery .owl-dot {\n  display: inline-block;\n  margin: 0 5px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #ddd;\n}\n\n#gallery .owl-dot.active {\n  background-color: #f82249;\n}\n\n#gallery .gallery-carousel .owl-stage-outer {\n  overflow: visible;\n}\n\n#gallery .gallery-carousel .center {\n  border: 6px solid #f82249;\n  margin: -10px;\n  box-sizing: content-box;\n  padding: 4px;\n  background: #fff;\n  z-index: 1;\n}\n\n.clients .clients-wrap {\n  border-top: 1px solid #f1eeed;\n  border-left: 1px solid #f1eeed;\n}\n\n.clients .client-logo {\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-right: 1px solid #f1eeed;\n  border-bottom: 1px solid #f1eeed;\n  overflow: hidden;\n  background: #fff;\n  height: 100px;\n}\n\n.clients .client-logo img {\n  transition: all 0.3s ease-in-out;\n  height: 60px;\n  -webkit-filter: grayscale(100%);\n  filter: grayscale(100%);\n}\n\n.clients .client-logo:hover img {\n  -webkit-filter: none;\n  filter: none;\n  transform: scale(1.1);\n}\n\n#footer {\n  background: #101522;\n  padding: 25px 0px;\n  color: #eee;\n  font-size: 14px;\n  text-align: center;\n  min-width: 100vw;\n  bottom: 0;\n}\n\n// @media (max-width: 1650) {\n//   #footer  {\n//     margin-top: 100px;\n//   }\n// }\n\n// @media (max-width: 900px) {\n//   #footer  {\n//     margin-top: 200px;\n//   }\n// }\n\n// @media (max-width: 480px) {\n//   #footer  {\n//     width: 20rem;\n//     height: 5rem;\n//   }\n// }\n\n\n.clicapLogo {\n  width: 60rem;\n  height: 15rem;\n}\n\n@media (max-width: 1200px) {\n  .clicapLogo {\n    width: 40rem;\n    height: 10rem;\n  }\n}\n\n@media (max-width: 900px) {\n  .clicapLogo {\n    width: 28rem;\n    height: 7rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .clicapLogo {\n    width: 20rem;\n    height: 5rem;\n  }\n}\n\n.introSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 2rem;\n}\n\n#count {\n  margin-top: 2rem;\n}\n\n*,\n*:before,\n*:after {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\ninput[type=\"date\"] {\n  background-color: #0080ff;\n  padding: 15px;\n  color: #ffffff;\n  font-size: 18px;\n  border: none;\n  outline: none;\n  border-radius: 5px;\n}\n::-webkit-calendar-picker-indicator {\n  background-color: #ffffff;\n  padding: 5px;\n  cursor: pointer;\n  border-radius: 3px;\n}\n\n.divIntro {\n  height: 33.33vh;\n}\n\n@media (max-width: 480px) {\n  .divIntro {\n    height: auto;\n    margin-bottom: 30px;\n  }\n}\n\n.img-authorities {\n  max-width: 80%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
